<template>
  <div class="d-flex justify-center align-center my-2">
    <v-card class="pa-6" max-width="440" elevation="6">
      <v-card-title class="text-h6">Отчет по кликам на баннера</v-card-title>
      <v-card-text>
        <v-form @submit.prevent="downloadReport"
          ref="form"
          lazy-validation
        >
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="form.dateStart"
                label="От"
                type="date"
                density="comfortable"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="form.dateFinish"
                label="До"
                type="date"
                density="comfortable"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="form.adId"
                :items="ads"
                item-text="location"
                item-value="id"
                label="Тип баннера"
                density="comfortable"
                :rules="[rules.required]"
              ></v-select>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="form.adItemContentId"
                :items="adItemContents"
                label="Баннер"
                density="comfortable"
                item-text="title"
                item-value="id"
                :rules="[rules.required]"
              ></v-select>
            </v-col>
            
            <v-col cols="12" class="text-center">
              <v-btn color="primary"
               type="submit"
               :loading="loading.getExcelReport"
               :disabled="loading.getExcelReport">
                Скачать отчет
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import { getCurrentDateString } from "../../utils/dateTime";

export default {
  data: () => ({
    form: {
      dateStart: getCurrentDateString(),
      dateFinish: getCurrentDateString(),
      adId: null,
      adItemContentId: null,
    },
    loading: {
      getExcelReport: false
    },
    bannerTypes: [],
    adItemContents: [],
    skus: [],
    ads: [],
    rules: {
      required: value => value !== '' && value != null || 'Обязательное поле',
    },
  }),
  methods: {
     downloadReport() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        window.console.log('Форма отправлена:', this.form);
        this.loading.getExcelReport = true;
        this.$store
        .dispatch("UPLOAD_AD_CLICKS_REPORT", this.form)
         .then(() => {
           this.loading.getExcelReport = false;
         })
         .catch((error) => {
          this.loading.getExcelReport = false;
           window.console.log(error);
        });
      }
    },
    GetAds() {
      this.$store
        .dispatch("ADS")
        .then(() => {
          this.ads = this.$store.getters.ADS;
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
  },
  created() {
    this.GetAds();
  },
  watch: {
    'form.adId': function (val) {
      window.console.log('val', this.ads[val].adItems);
      this.adItemContents = this.ads[val].adItems.flatMap(item => item.adItemContents);
      window.console.log('banners', this.adItemContents);
    },
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 12px;
}
.fill-height {
  height: 100vh;
}
</style>